require('./bootstrap');

window.Vue = require('vue').default;
import VueSweetalert2 from 'vue-sweetalert2';
import Utility from './plugins/Utility';

// Vuex Store
import store from './store/store'

// i18n
import i18n from './i18n/i18n'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing);
Vue.use(Utility);
Vue.use(VueSweetalert2);
Vue.config.productionTip = false

// layouts
import LayoutHeader from './layouts/Header';
import LayoutFooter from './layouts/Footer';
import LayoutSearch from './layouts/Search';
import LayoutRightMenu from './layouts/RightMenu';
import LayoutPopMenu from './layouts/PopMenu';
import LayoutPopShare from './layouts/PopShare';

// homePage
import HomeHero from './components/home/Hero.vue';
import HomeNews from './components/home/News.vue';
import HomeIntro from './components/home/Intro.vue';
import HomeAbout from './components/home/About.vue';
import HomeAboutPopVideo from './components/home/AboutPopVideo.vue';

// 
import PageFaq from './pages/Faq.vue';
import PageContent from './pages/Content.vue';


// import LayoutPopShare from './layouts/PopShare';
// Vue.component('home-hero', require('./components/home/Hero.vue').default);

// components

new Vue({
    el: '#app',
    store,
    i18n,
    components: {
        LayoutHeader,
        LayoutFooter,
        LayoutSearch,
        LayoutRightMenu,
        LayoutPopMenu,
        LayoutPopShare,

        // homePage
        HomeHero,
        HomeNews,
        HomeIntro,
        HomeAbout,
        HomeAboutPopVideo,

        PageFaq,
        PageContent,
    }
});
